import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DataARLedgerListModel} from '../../models/data-ar-ledger-list.model';
import {DataARPaymentListModel} from '../../models/data-ar-payment-list.model';
import {DataArLedgerItemProcedureAdjustments} from '../../models/data-ar-ledger-item-procedure-adjustments';
import {EnumARPaymentType} from '../../../../models/enum/enum-ar-payment-type';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';

@Component({
  selector: 'app-ar-ledger-procedure-details',
  templateUrl: './ar-ledger-procedure-details.component.html',
  styleUrls: ['./ar-ledger-procedure-details.component.scss']
})
export class ArLedgerProcedureDetailsComponent implements OnInit {

  isLoading: boolean = false;
  ledgerItem: DataARLedgerListModel;
  ledgerItems: DataARLedgerListModel[] = [];
  distributions: DataARPaymentListModel[] = [];
  distributionsPatient: DataARPaymentListModel[] = [];
  distributionsInsurance: DataARPaymentListModel[] = [];
  adjustmentsPatient: DataArLedgerItemProcedureAdjustments[] = [];
  adjustmentsInsurance: DataArLedgerItemProcedureAdjustments[] = [];

  enumLedgerItemTypeClaimCreated: string = '00000078-1000-0000-0000-000000000009';
  enumLedgerItemTypeCreditPayment: string = '00000078-1000-0000-0000-000000000004';
  enumLedgerItemTypeCreditAdjustment: string = '00000078-1000-0000-0000-000000000007';
  enumLedgerItemTypeCreditAdjustmentInsurance: string = '00000078-1000-0000-0000-000000000008';
  enumLedgerItemTypeDebitAdjustment: string = '00000078-1000-0000-0000-000000000006';
  enumLedgerItemTypeCredit: string = '00000078-1000-0000-0000-000000000001';
  enumLedgerItemTypeDebit: string = '00000078-1000-0000-0000-000000000002';
  enumLedgerItemTypeRefund: string = '00000078-1000-0000-0000-000000000005';
  enumLedgerItemTypeWriteOff: string = '00000078-1000-0000-0000-000000000003';
  //enumLedgerItemTypeDebitPatientPay: string = '00000078-1000-0000-0000-000000000012';

  enumARLedgerItemOriginTypeTransaction: string = '00000207-1000-0000-0000-000000000003';
  enumARLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumARLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';

  enumARDistribItemStatusVoid: string = '00000535-1000-0000-0000-000000000002';

  constructor(
    public dialogRef: MatDialogRef<ArLedgerProcedureDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.ledgerItem = this.data.dataLedgerItem;
    this.ledgerItems = this.data.dataLedgerItems;
    this.init();
  }

  async init() {
    const promises: any[] = [
      this.getPaymentDistributionsList(), // get credits too?? debits??
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.distributions = results[0];
      this.distributionsPatient = this.distributions.filter(a => (a.enumPaymentSourceID === PAYMENT_SOURCE.Patient || a.enumPaymentSourceID === PAYMENT_SOURCE.ApplyCredit) || (a.PaymentDistributionTypeName === 'Write Off' && a.enumPaymentSourceID != PAYMENT_SOURCE.Insurance));
      this.distributionsInsurance = this.distributions.filter(a => a.enumPaymentSourceID === PAYMENT_SOURCE.Insurance);

      // build adjustments lists
      this.distributionsInsurance.forEach(a => {
        const adj = new DataArLedgerItemProcedureAdjustments();
        adj.Amount = a.PaymentAmount;
        adj.debitCredit = 'credit';
        adj.Date = ConversionUtilities.convertUTCDateToLocalDateFromString(a.PaymentDistributionDate);
        adj.Type = a.PaymentDistributionTypeName;
        adj.PaymentSource = this.returnPaymentType(a.enumARPayementTypeID);
        adj.PaymentDistributionStatus = a.PaymentDistributionStatus;
        adj.PaymentDistributionTypeName = a.PaymentDistributionTypeName;

        if (a.PaymentDistributionStatus === this.enumARDistribItemStatusVoid) {
          adj.PaymentSource = 'VOID - ' + adj.PaymentSource;
        }
        else if (adj.Type.toUpperCase().includes('WRITE')) {
          adj.PaymentSource = a.PaymentDistributionTypeName;
        }

        this.adjustmentsInsurance.push(adj);
      });

      this.distributionsPatient.forEach(a => {
        const adj = new DataArLedgerItemProcedureAdjustments();
        adj.Amount = a.PaymentAmount;
        adj.debitCredit = 'credit';
        adj.Date = a.PaymentDistributionDate;
        adj.Type = a.PaymentDistributionTypeName;
        adj.PaymentSource = this.returnPaymentType(a.enumARPayementTypeID);
        adj.PaymentDistributionStatus = a.PaymentDistributionStatus;
        adj.PaymentDistributionTypeName = a.PaymentDistributionTypeName;

        if (a.enumPaymentSourceID === PAYMENT_SOURCE.ApplyCredit) {
          adj.PaymentSource = 'Patient Credit';
        }

        if (a.PaymentDistributionStatus === this.enumARDistribItemStatusVoid) {
          adj.PaymentSource = 'VOID - ' + adj.PaymentSource;
        }

        this.adjustmentsPatient.push(adj);
      });

      this.ledgerItems = this.ledgerItems.filter(a => a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.DebitPatientPay);
      this.ledgerItems.forEach(a => {
        const adj = new DataArLedgerItemProcedureAdjustments();
        adj.Amount = a.Amount;
        adj.debitCredit = a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.DebitPatientPay ? 'debit' : '';
        adj.Date = a.PostDate;

        if (a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.DebitPatientPay) { 
          adj.PaymentSource = 'Patient Responsibility'; 
          adj.PaymentDistributionTypeName = 'Insurance Short Pay';
        }
        else { adj.PaymentSource = ''; }

        if (a.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypePatient) {
          this.adjustmentsPatient.push(adj);
        }
      });

      this.isLoading = false;
    }
    catch (err) {
      console.log(err);
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    }
  }

  returnProperName(PaymentDistributionTypeName: string) {
    if (PaymentDistributionTypeName) { PaymentDistributionTypeName = PaymentDistributionTypeName.toUpperCase(); }
    if (PaymentDistributionTypeName === 'STANDARD') {
      return 'Payment';
    }
  }

  getPaymentDistributionsList() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getPaymentDistributionsForLedgerTransaction(this.ledgerItem.ARTransactionItemID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  close() {
    this.dialogRef.close();
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  returnPaymentType(id: string) {
    if (EnumARPaymentType.Check === id) { return 'Check'; }
    else if (EnumARPaymentType.Cash === id) { return 'Cash'; }
    else if (EnumARPaymentType.CreditCard === id) { return 'Credit Card'; }
    else if (EnumARPaymentType.CreditCardOffline === id) { return 'Credit Card Offline'; }
    else { return ''; }
  }

  isVoidedDistribution(item: DataArLedgerItemProcedureAdjustments) {
    if (item.PaymentDistributionStatus === this.enumARDistribItemStatusVoid) {
      return true;
    }
    else {
      return false;
    }
  }
}
